import { useState, useMemo } from 'react';

interface UseeExpandableTextResult {
    text: string;
    isExpanded: boolean;
    toggle: () => void;
    isOverflowing: boolean;
}

interface UseExpandableTextOptions {
    maxLength?: number;
    ellipsis?: string;
}

export default function useExpandableText(
    input: string,
    { maxLength = 100, ellipsis = '...' }: UseExpandableTextOptions = {},
): UseeExpandableTextResult {
    const [isExpanded, setIsExpanded] = useState(false);

    const isOverflowing = input?.length > maxLength;

    const displayText = useMemo(() => {
        if (!isOverflowing || isExpanded) return input;

        return input.slice(0, maxLength) + ellipsis;
    }, [input, maxLength, ellipsis, isExpanded, isOverflowing]);

    const toggle = () => setIsExpanded((prev) => !prev);

    return { text: displayText, isExpanded, toggle, isOverflowing };
}
